export default "/images/analytics.png?2c513331c41a9791c98901d8582e8132";